import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

export default function VariableSidebar() {
    const { survey_id } = useSelector((state) => state.permissionsData)
    const { t, i18n } = useTranslation();

    return (
        <>
            <div className="nested-menu">
                <div className="menu-title mb-2">
                    <p>{t('survey.variable.heading')}</p>
                </div>
                <div className="menu-items">
                    <ul>
                        <li>
                            <NavLink to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}  >
                            {t('survey.variable.heading1')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/admin/survey/create/custom-variable?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}>
                            {t('survey.customVariable.customVariables')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/admin/survey/create/custom-formulas?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}>
                            {t('survey.customFormula.custom_formula')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/admin/survey/create/utm-campaign?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}>
                            {t('survey.utm.title')}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/admin/survey/create/stages?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}>
                            {t('survey.stages.title')}
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}